/**
 * @format
 */

import { api } from '@/scripts/api';

export const MDFInvoicesService = {
    getAll(options = {}, accountId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/invoices/account/${accountId}?${options}`;
            api.get(service).then(resolve).catch(reject);
        });
    },

    getClientHasBankAccount({ invoiceId, clientAccountId }) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/invoices/partner-has-bank-account-info/account/${clientAccountId}/invoice/${invoiceId}`;
            api.get(service).then(resolve).catch(reject);
        });
    },

    getInvoiceById(invoiceId, accountId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/invoices/view-details/account/${accountId}/invoice/${invoiceId}`;
            api.get(service).then(resolve).catch(reject);
        });
    },

    getPaymentDetailsById(invoiceId, accountId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/invoices/agency-account/${accountId}/payment-details/${invoiceId}`;
            api.get(service).then(resolve).catch(reject);
        });
    },

    makePayment(body, invoiceId, accountId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/invoices/agency-account/${accountId}/invoice/${invoiceId}/make-payment`;
            api.post(service, body).then(resolve).catch(reject);
        });
    },

    notifyPartnerAccountExistence({ invoiceId, accountId }) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/invoices/notify-partner-need-bank-account/account/${accountId}/invoice/${invoiceId}`;
            api.post(service).then(resolve).catch(reject);
        });
    },

    paymentMark(invoiceId, accountId, body) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/invoices/agency-account/${accountId}/invoice/${invoiceId}/payment-mark`;
            api.put(service, body).then(resolve).catch(reject);
        });
    },

    postExportCsv(accountId, body) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/csv-export/agency-account/${accountId}/mdf-invoices`;
            api.post(service, body).then(resolve).catch(reject);
        });
    },
};
